import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { RightIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import EditorFieldOptionBase from '../../../editor/EditorFieldOptionBase';
import { Flex } from 'foundations-components/components/Flex';
import { useHovered } from 'foundations-components/transitional/utils/useHovered';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledEditorOptionBase = styled(EditorFieldOptionBase)(({
  theme,
  disabled
}) => ({
  '&&&': {
    paddingRight: theme.space[100],
    cursor: disabled ? 'not-allowed' : undefined,
    color: disabled ? theme.color['text-primary-disabled'] : undefined,
    '&:hover, &:active, &:focus': {
      textDecoration: disabled ? 'none' : 'underline',
      backgroundColor: disabled ? 'transparent' : undefined
    }
  }
}));
const StyledRightIconContainer = styled.span.withConfig({
  displayName: "GroupOption__StyledRightIconContainer",
  componentId: "ou4o6u-0"
})(({
  disabled,
  hovered
}) => ({
  textDecoration: 'unset',
  opacity: hovered ? 1 : 0,
  display: disabled ? 'none' : undefined
}));
const GroupOption = ({
  categoryLabel,
  dataSeleniumInfo,
  dataSeleniumTest,
  disabled,
  hideIcon,
  onClick
}) => {
  const dataOnboardingAttributeValue = `filter-category-option-${categoryLabel.toLowerCase().replace(/\s/gi, '-')}`;
  const {
    hovered,
    onMouseEnter,
    onMouseLeave,
    onMouseMove
  } = useHovered({});
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disabled,
    placement: "bottom",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterEditorOperatorCreate.duplicateFilterFamilyMessage"
    }),
    use: "longform",
    children: /*#__PURE__*/_jsx(StyledEditorOptionBase, {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseMove: onMouseMove,
      "data-onboarding": dataOnboardingAttributeValue,
      "data-selenium-info": dataSeleniumInfo,
      "data-selenium-test": dataSeleniumTest,
      disabled: disabled,
      onClick: onClick,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx("span", {
          children: categoryLabel
        }), !hideIcon && /*#__PURE__*/_jsx(StyledRightIconContainer, {
          disabled: disabled,
          hovered: hovered,
          children: /*#__PURE__*/_jsx(RightIcon, {
            color: "icon-interactive-default",
            size: "400"
          })
        })]
      })
    })
  });
};
export default GroupOption;